<template>
  <div
    class="swiper-info-container"
    ref="headerSwiperRef"
    @mouseenter="showNavigation"
    @mouseleave="hideNavigation"
  >
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item, index) in list" :key="index">
        <img
          :src="item.url"
          alt="轮播图"
          style="width: 100%; cursor: pointer"
        />
      </div>
    </div>
    <div class="swiper-pagination"></div>
    <div class="swiper-button-prev swiper-button" ref="prevRef">
      <img
        src="../../assets/images/prev.png"
        alt=""
      />
    </div>
    <div class="swiper-button-next swiper-button" ref="nextRef">
      <img
        src="../../assets/images/next.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  name: "SwiperInfo",
  props: {
    list: {
      required: true,
      type: Array,
      default: () => [],
    },
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.swiper = null;
          this.swiper = new Swiper(this.$refs.headerSwiperRef, {
            loop: true,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 2,
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: this.$refs.nextRef,
              prevEl: this.$refs.prevRef
            },
            speed: 1000,
            grabCursor: true,
            centerInsufficientSlides: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
              waitForTransition: true,
            },
          });

          this.hideNavigation();
        });
      },
    },
  },
  methods: {
    showNavigation() {
      this.$refs.prevRef.style.display = "flex";
      this.$refs.nextRef.style.display = "flex";
    },
    hideNavigation() {
      this.$refs.prevRef.style.display = "none";
      this.$refs.nextRef.style.display = "none";
    },
  },
  beforeDestroy() {
    this.swiper = null;
  },
};
</script>
<style lang="scss" scoped>
.swiper-info-container {
  position: relative;
  max-width: 100%;
  overflow: hidden;
  ::v-deep {
    .swiper-pagination-bullet {
      margin: 0 5px;
      border-radius: 2px;
    }
    .swiper-pagination > span {
      width: 86px;
      height: 3px;
      display: inline-block;
    }

    .swiper-pagination-bullet {
      background: #fff;
      opacity: 0.8;
    }
    .swiper-pagination-bullet-active {
      background: #000;
    }

    .swiper-button-next,
    .swiper-button-prev {
      &::after {
        content: none;
      }
    }
  }

  .swiper-button {
    width: 40px;
    height: 40px;
    background: rgba(162, 162, 162, 0.7);
    position: absolute;
    top: 50%;
    text-align: center;
    transition: all 0.3s linear;
    display: flex;
    justify-content: center;
    align-items: center;

    > img {
      width: 60%;
      opacity: 1;
    }
  }
}
</style>
